import { BrowserRouter } from 'react-router-dom';
import MainComponent from './Component/MainComponent';
import axios from 'axios'
import analytics from './firebase.config';
import Swal from 'sweetalert2'
import { getAnalytics, logEvent } from "firebase/analytics";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
require('dotenv').config()
function App() {

  Sentry.init({
    dsn: "https://2f022a406ff2483a99435948926d9e5c@o1191462.ingest.sentry.io/6432818",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });

  axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data



    return response;
  }, function (error) {
    logEvent(analytics, 'inactivity_user_logged_out');



    if (error.message.includes('401')) {
      if (!error.response.data.message.includes('Email not verified')) {


        localStorage.clear();
        window.location.href = '/';
      }

    }

    if (error?.message == 'Network Error') {


      Swal.fire(
        'Error',
        'Network Connection was Lost',
        'question'
      )

      // Swal.fire({
      //   title: 'You’re almost there!',
      //   text: "Are you sure you want to exit the account opening form? It only takes a couple of minutes to finish.",
      //   icon: 'success',
      //   showCancelButton: true,
      //   confirmButtonColor: '#e5386a',
      //   // cancelButtonColor: '#d33',
      //   cancelButtonText: "Continue",
      //   // showDenyButton: true,
      //   // showCancelButton: true,
      //   confirmButtonText: 'Exit',
      //   // denyButtonText: `Don't save`,
      //   showClass: {
      //     popup: 'animate__animated animate__fadeInDown'
      //   },
      //   hideClass: {
      //     popup: 'animate__animated animate__fadeOutUp'
      //   }
      // }).then((result) => {  })



    }

    if (error.response.data.message == 'Not found') {


      // setModalother(true)
      // setMessage('Sorry The Request Can not be Fullfilled Now')

    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });

  const handelFeedback = () => {
    logEvent(analytics, 'general_open_feedback');
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdRtcPYuA9gyDKrl6UvO6V_Eum1fATjdZusAy21fsH_xFyNNQ/viewform', '_blank').focus();

  }



  return (
    <> <div className="feedback cursor" onClick={() => handelFeedback()}>
      <FeedBackButton />
    </div>
      <div className="feedback-bottom cursor" onClick={() => handelFeedback()}>
        <p className="feedback-text my-2">Feedback</p>
      </div>

      <BrowserRouter>
        <MainComponent />
      </BrowserRouter>
    </>
  );
}

export default App;
const FeedBackButton = () => (
  <svg width="40" height="114" viewBox="0 0 40 114" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 114C3.58172 114 4.27116e-08 110.418 9.5399e-08 106L1.26404e-06 8C1.31672e-06 3.58172 3.58172 4.27116e-08 8 9.5399e-08L40 4.76995e-07L40 114L8 114Z" fill="#E92A5E" fillOpacity="0.2" />
    <path d="M25 86.43L20.618 86.43L20.618 83.154L18.518 83.154L18.518 86.43L16.67 86.43L16.67 82.902L14.444 82.902L14.444 89.02L25 89.02L25 86.43ZM21.612 74.8739C19.19 74.8739 17.79 76.4139 17.79 78.6539C17.79 80.7959 19.218 82.4199 21.528 82.4199C23.838 82.4199 25.182 80.7959 25.182 78.5699C25.182 77.0159 24.496 75.5739 23.054 74.9859L22.648 77.2959C23.222 77.5899 23.516 77.9819 23.516 78.5559C23.516 79.4239 22.886 79.8439 21.962 79.8859L21.962 74.8879C21.85 74.8739 21.738 74.8739 21.612 74.8739ZM20.576 79.8299C19.918 79.7179 19.456 79.2979 19.456 78.6119C19.456 77.9259 19.89 77.4639 20.576 77.3939L20.576 79.8299ZM21.612 66.6073C19.19 66.6073 17.79 68.1473 17.79 70.3873C17.79 72.5293 19.218 74.1533 21.528 74.1533C23.838 74.1533 25.182 72.5293 25.182 70.3033C25.182 68.7493 24.496 67.3073 23.054 66.7193L22.648 69.0293C23.222 69.3233 23.516 69.7153 23.516 70.2893C23.516 71.1573 22.886 71.5773 21.962 71.6193L21.962 66.6213C21.85 66.6073 21.738 66.6073 21.612 66.6073ZM20.576 71.5633C19.918 71.4513 19.456 71.0313 19.456 70.3453C19.456 69.6593 19.89 69.1973 20.576 69.1273L20.576 71.5633ZM25.168 62.5827C25.168 61.7147 24.79 60.9727 24.09 60.3987L24.09 60.3707L25 60.3847L25 57.9207L13.576 57.9207L13.576 60.4407L17.538 60.4407C17.874 60.4407 18.434 60.4267 18.826 60.3987L18.826 60.4127C18.168 60.9727 17.79 61.7147 17.79 62.6247C17.79 64.6687 19.484 65.8867 21.486 65.8867C23.46 65.8867 25.168 64.6267 25.168 62.5827ZM23.11 61.8547C23.11 62.7787 22.41 63.3807 21.486 63.3807C20.534 63.3807 19.862 62.8067 19.862 61.8547C19.862 60.9307 20.534 60.3007 21.472 60.3007C22.41 60.3007 23.11 60.9307 23.11 61.8547ZM25.168 51.7595C25.168 49.7155 23.46 48.4555 21.486 48.4555C19.484 48.4555 17.79 49.6875 17.79 51.7315C17.79 52.6415 18.168 53.3695 18.826 53.9295L18.826 53.9435C18.392 53.9295 17.874 53.9155 17.538 53.9155L13.576 53.9155L13.576 56.4355L25 56.4355L25 53.9575L24.09 53.9575L24.09 53.9435C24.79 53.3695 25.168 52.6415 25.168 51.7595ZM23.11 52.4875C23.11 53.4255 22.41 54.0415 21.472 54.0415C20.534 54.0415 19.862 53.4255 19.862 52.4875C19.862 51.5355 20.534 50.9755 21.486 50.9755C22.41 50.9755 23.11 51.5635 23.11 52.4875ZM25.182 44.4503C25.182 43.5543 24.818 42.9103 24.146 42.2383L24.146 42.2243L25 42.2383L25 39.7603L17.972 39.7603L17.972 42.2383L18.784 42.2243L18.784 42.2383C18.084 42.8543 17.804 43.5683 17.804 44.4363C17.804 46.4383 19.512 47.7403 21.5 47.7403C23.502 47.7403 25.182 46.4663 25.182 44.4503ZM23.124 43.7083C23.124 44.6603 22.438 45.2203 21.486 45.2203C20.562 45.2203 19.862 44.6183 19.862 43.6943C19.862 42.7703 20.562 42.1403 21.5 42.1403C22.438 42.1403 23.124 42.7703 23.124 43.7083ZM25.182 34.8031C25.182 34.1171 25 33.4171 24.748 32.9551L22.424 32.8851C22.872 33.4171 23.124 33.9071 23.124 34.5371C23.124 35.5451 22.396 36.1191 21.486 36.1191C20.52 36.1191 19.834 35.4891 19.834 34.5231C19.834 33.8651 20.114 33.3611 20.576 32.8851L18.224 32.8851C17.986 33.3611 17.79 34.1171 17.79 34.9291C17.79 37.1411 19.414 38.6671 21.514 38.6671C23.754 38.6671 25.182 37.0851 25.182 34.8031ZM21.164 27.0155L17.972 24.2015L17.972 27.1695L20.506 29.1295L13.576 29.1295L13.576 31.6495L25 31.6495L25 29.1295L22.354 29.1295L22.2 28.8775L25 27.0295L25 24.0195L21.164 27.0155Z" fill="#E92A5E" />
  </svg>

)